/*
  Sticky shop bar controller — vanilla, deferred.
  Reveals the bar once the visitor has scrolled past the hero (or ~80vh
  on pages without the cinematic hero), hides it again near the footer,
  and lets the visitor dismiss it for the session (sessionStorage). ESC
  dismisses while it's visible. Reduced motion is handled in CSS (no
  slide); JS logic is identical either way.
*/
(() => {
  'use strict';

  const bar = document.querySelector('[data-tt-shopbar]');
  if (!bar) return;

  const KEY = 'tt-shopbar-dismissed';
  if (sessionStorage.getItem(KEY) === '1') { bar.remove(); return; }

  bar.hidden = false; // take it out of [hidden]; CSS keeps it off-screen until --visible

  const hero = document.querySelector('[data-tt-cine]');
  const footer = document.querySelector('.footer, footer');
  let visible = false;

  const revealThreshold = () => (hero ? hero.offsetHeight : window.innerHeight * 0.8);

  const setVisible = (v) => {
    if (v === visible) return;
    visible = v;
    bar.classList.toggle('tt-shopbar--visible', v);
  };

  let ticking = false;
  const update = () => {
    ticking = false;
    const y = window.scrollY;
    const pastHero = y > revealThreshold();
    // hide as the footer enters the viewport (so it doesn't overlap it)
    let nearFooter = false;
    if (footer) {
      const fRect = footer.getBoundingClientRect();
      nearFooter = fRect.top < window.innerHeight - 40;
    }
    setVisible(pastHero && !nearFooter);
  };

  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(KEY, '1');
    // remove after it has slid away
    setTimeout(() => bar.remove(), 400);
  };

  bar.querySelector('[data-tt-shopbar-close]')?.addEventListener('click', dismiss);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && visible) dismiss();
  });
})();
